<template>
<div class="chapter">
<div class="inner_page">
<p class="block_7" id="calibre_pb_4"> </p>
<h1 class="block_114" id="id_Toc151366858">My Wish</h1>
<p class="block_"> </p>
<p class="block_2">My book of poems is about me and all of us—the quick, the dead, and generations to come.</p>
<p class="block_2">It holds poems about us, living the life that we lead and envisioning the one we can potentially create.</p>
<p class="block_2">It’s filled with poems about realising our dreams and inspiring others to pursue theirs, too.</p>
<p class="block_2">It’s a collection of verses about a world imbued with peace, enchantment, and fulfilment for everyone.</p>
<p class="block_2">You’ll find poems defying the constraints and myths that seek to hold us down.</p>
<p class="block_2">It contains words about evolving through time while remaining discerning and mighty.</p>
<p class="block_2">It pays tribute and honour to the successes and victories of humanity through poignant poems.</p>
<p class="block_2">It lets imaginations and aspirations travel to worlds beyond, sowing seeds for the advancement of this generation.</p>
<p class="block_2">Finally, it’s about fantasies and dreams—for it’s from these that we cultivate our minds to augment logic and inaugurate novelty.</p>
<p class="block_3" id="calibre_pb_5"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_004.vue?df09cb4c